import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const Container = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  padding: ${theme.spacing.medium};
  background-color: ${theme.colors.background};
`;

const Title = styled.h1`
  color: ${theme.colors.titleText};
  text-align: center;
  margin-bottom: ${theme.spacing.large};
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing.large};
`;

const SectionTitle = styled.h2`
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.medium};
`;

const Text = styled.p`
  color: ${theme.colors.text};
  line-height: 1.6;
  margin-bottom: ${theme.spacing.medium};
`;

const Disclaimer: React.FC = () => {
  return (
    <Container>
      <Title>Disclaimer</Title>

      <Section>
        <SectionTitle>1. Application Usage</SectionTitle>
        <Text>
          Ufi IPTV application is provided for personal, non-commercial use only. Users are responsible
          for ensuring they have the right to access the content in their jurisdiction.
        </Text>
      </Section>

      <Section>
        <SectionTitle>2. Content Disclaimer</SectionTitle>
        <Text>
          We do not host, own, or distribute any of the content available through our application.
          All content is provided by third-party sources. We are not responsible for the accuracy,
          legality, or content of any external sources.
        </Text>
      </Section>

      <Section>
        <SectionTitle>3. User Responsibilities</SectionTitle>
        <Text>
          Users are responsible for maintaining the security of their account credentials and
          for all activities that occur under their account. Users must comply with all
          applicable laws and regulations.
        </Text>
      </Section>

      <Section>
        <SectionTitle>4. Limitation of Liability</SectionTitle>
        <Text>
          We shall not be liable for any indirect, incidental, special, consequential, or
          punitive damages resulting from your use of or inability to use the application.
        </Text>
      </Section>

      <Section>
        <SectionTitle>5. Changes to Disclaimer</SectionTitle>
        <Text>
          We reserve the right to modify this disclaimer at any time. Continued use of the
          application after such modifications constitutes acceptance of the updated terms.
        </Text>
      </Section>
    </Container>
  );
};

export default Disclaimer;